(function($, App, Utils, Components){
  'use strict';

  var logger = new Logger("Cookies");

  Components.create('Cookies', {

    cookiesAccepted: 'cookies:accepted',

    cookiesMissing: 'cookies:missing',
    
    markup: function() {
      var html = '';

      html += '<div class="cookies-disclaimer">';
      html += '<div class="container">';
      html += '  <div class="text-center">';
      html += '    <p></p>';
      html += '    </div>';
      html += '  </div>';
      html += '</div>';

      return $(html);
    },

    accept: function() {
        Cookies.set(Components.Cookies.cookieName, 'true', { expires: Components.Cookies.expires, path: Components.Cookies.path });
        App.Body.removeClass('cookies');

        logger.log('Triggering:', Components.Cookies.cookiesAccepted);
        App.Body.trigger(Components.Cookies.cookiesAccepted);

        $(App.Document).off('scroll click');
    },

    start: function() {

      if ( typeof(CookiesSetup) == 'undefined' ) {
        logger.warn("No 'CookiesSetup' found, skipping cookies initialization.");
        return;
      }

      $.extend(this, CookiesSetup);

      // Shows cookies disclaimer if not yet accepted.
      if (!Cookies.get(Components.Cookies.cookieName) && $(".cookies-disclaimer").length == 0) {

        logger.log("Cookie policy not accepted");
        var
          self = Components.Cookies.markup(),
          message = $.parseHTML(Components.Cookies.message);
          message = message[0].data;

        self.find('p').append( message ).append( $('<button class="btn btn-primary">' + Components.Cookies.button + '</button>') );

        App.Body.append(self);
        App.Body.addClass('cookies');

        // Cookies policy acceptance
        $('.cookies-disclaimer .btn').on('click', Components.Cookies.accept);
        $(App.Document).on('scroll click', Components.Cookies.accept);

        logger.log('Triggering:', Components.Cookies.cookiesMissing);
        App.Body.trigger(Components.Cookies.cookiesMissing);

      } else {

        App.Body.trigger(Components.Cookies.cookiesAccepted);
      }
    },

    init: function() {
      $(Utils.Browsers.target).on(Utils.Browsers.detectedEvent, function() {
        Components.Cookies.start();
      });
    }

  });

})(jQuery, window.App, window.App.Utils, window.App.Components);
